import {observer, Popover2, React, useAsObservableSource, useEffect} from '@api'
import {BuilderCardLoader, LoadingIndicator, useVipLocalStore, utils} from '@modules'
import {CatalogItemCardShape, useTldrawApp, useWhiteboardStore} from '@modules/whiteboard'
import * as css from './CatalogItemShape.css'
import {CatalogItemShapeStore, CatalogItemShapeStoreContext, useCatalogItemShapeStore} from './'
import {HTMLContainer, TLComponentProps, TLShapeUtil} from '@tldraw/core'
import {PrimaryIconButton} from 'centric-ui-components'

export const CatalogItemShapeComponent = observer<TLComponentProps<CatalogItemCardShape>, HTMLDivElement>(function CatalogItemCardShapeComponentInternal(props, ref) {
  const app = useTldrawApp(),
    obsProps = useAsObservableSource({...props, app}),
    store = useVipLocalStore((stores) => new CatalogItemShapeStore(stores, obsProps))

    useEffect(() => store.registerEffects(), [])

  return (
    <CatalogItemShapeStoreContext.Provider value={store}>
      {/*<div className="tl-positioned-div" ref={ref} {...events}>*/}
      <HTMLContainer ref={ref} {...props.events}>
        <CatalogItemShapeInternal />
      </HTMLContainer>
    </CatalogItemShapeStoreContext.Provider>
  )
}, {forwardRef: true})

const CatalogItemShapeInternal = observer(function CatalogItemShapeInternal() {
    const {whiteboard: {tab}, setRef, builderCardPopoverProps, builderCardProps, popoverCard, workspaceConfig,
      props: {isSelected, isGhost, shape: {cardData, name}}, style, baseStore: {isResizing}, toggleShowPopover, cardData: {showDetailsPopover}} = useCatalogItemShapeStore()

  // useEffect(() => {
  //   console.log(`Mount CatalogItemShapeInternal`)
  //   return () => console.log(`Unmount CatalogItemShapeInternal`)
  // }, [])

    return (
      <div className={css.shapeRoot}
           data-selected={isSelected}
           data-ghost={isGhost}
           data-resizing={isResizing}
           style={style}
           data-popover-showing={showDetailsPopover}
        // onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave}
        // onPointerDown={onPointerDown} onPointerUp={onPointerUp} onPointerMove={onPointerMove}
      >
        <div className={css.contents}>
          {!cardData?.itemId
           ? <div>Invalid data</div>
           : !workspaceConfig
             ? <div className={css.loading} />
             : <Popover2
               className={css.popoverWrapper}
               popoverClassName={css.popover}
               position='right'
               isOpen={showDetailsPopover === true && tab.isSelected}
               usePortal
               modifiers={{
                 offset: {
                   enabled: true,
                   options: {
                     offset: [0, 8]
                   }
                 }
               }}
               content={<div className={css.popoverContents}>
                 {popoverCard && <div className={css.toolbar}>
			         <PrimaryIconButton tooltipPosition='right' tooltipStyle='mui' tooltip='Close' icon='cross' onClick={toggleShowPopover}/>
		         </div>}
                 <BuilderCardLoader {...builderCardPopoverProps} />
               </div>}
             >
               <BuilderCardLoader
                 ref={setRef}
                 className={css.card}
                 {...builderCardProps}
               />
             </Popover2>}

          {name ? <div className={css.shapeLabel}>
            <label>{name}</label>
          </div> : null}
        </div>
      </div>
    )
})
export const CardTitleLabel = observer(function ShapeTitleLabel() {
  const {title, isSelected} = useCatalogItemShapeStore()

  return (<div className={css.title} data-visible={isSelected && title != null}>
    <label>{title}</label>
  </div>)
})




// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/catalogItem/CatalogItemShapeComponent.tsx